import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { CONSTANTS, EMPTY_ARRAY } from '../constants/Constants';
const {
  ACTIONS
} = CONSTANTS;
const initialState = {
  cards: [],
  groups: [],
  groupTypes: [],
  favPinnedCards: []
};

/* - Reducer for cards.
 * @params
 *  - prevState - object
 *  - action - object
 * @return
 *  - state - object
 */
export default ((prevState, action) => {
  const state = prevState || initialState;
  switch (action.type) {
    case ACTIONS.FETCH_GET_CARD_LIST_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        cards: action.payload.cards || EMPTY_ARRAY,
        groups: action.payload.groups || EMPTY_ARRAY,
        groupTypes: action.payload.groupTypes || EMPTY_ARRAY
      });
    case ACTIONS.FETCH_GET_CARD_LIST_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        error: action.payload
      });
    case ACTIONS.FETCH_GET_FAVCARD_LIST_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        favPinnedCards: action.payload.application_pins
      });
    case ACTIONS.FETCH_GET_FAVCARD_LIST_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        error: action.payload
      });
    default:
      return state;
  }
});